import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import reportWebVitals from '@/reportWebVitals';
import App from "@/App";
import { ErrorBoundary } from '@/components';
import { initSentry } from '@/lib/sentry';

// Initialize Sentry before rendering
initSentry();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <App/>
        </ErrorBoundary>
    </React.StrictMode>
);
reportWebVitals();
